module.exports = __webpack_public_path__ + "static/media/ViveProductDesignStefWongUX.1212392f.mov";